import React from 'react';

import styled from 'styled-components';
import { Divider1 } from 'styles/common';

import theme from 'constants/theme';

import { Typography1 } from 'uiToolkit/Typography';

import { Step1 } from './Step1Section';
import { Step2 } from './Step2Section';

const Header = () => (
  <Typography1 color={theme.palette.text.blackv1} weight={600} style={{ fontSize: '24px', lineHeight: '36px' }}>
    Welcome to Develop
  </Typography1>
);

const Container = styled.div`
  padding: 1.5rem 1.5rem 3rem 1.5rem;
`;

export default function WelcomeScreen({ employee, isOneOnOne = false }) {
  return (
    <Container>
      <Header />
      <Step1 employee={employee} source={isOneOnOne ? '1:1' : 'LevelUp tab'} />
      <Divider1 />
      <Step2 />
    </Container>
  );
}
